import { render, staticRenderFns } from "./BancoReactivos.vue?vue&type=template&id=560a21d2&scoped=true"
import script from "./BancoReactivos.vue?vue&type=script&lang=js"
export * from "./BancoReactivos.vue?vue&type=script&lang=js"
import style0 from "./BancoReactivos.vue?vue&type=style&index=0&id=560a21d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a21d2",
  null
  
)

export default component.exports